import { RootState } from "@/types/General";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WishlistState {
  wishlistProductIds: number[];
}

const initialState: WishlistState = {
  wishlistProductIds: [],
};

export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    setWishlistProductIds: (state, action: PayloadAction<number[]>) => {
      state.wishlistProductIds = action.payload;
    },
    addToWishlistState: (state, action: PayloadAction<number>) => {
      if (!state.wishlistProductIds.includes(action.payload)) {
        state.wishlistProductIds.push(action.payload);
      }
    },
    removeFromWishlistState: (state, action: PayloadAction<number>) => {
      state.wishlistProductIds = state.wishlistProductIds.filter(
        (id) => id !== action.payload
      );
    },
    toggleWishlistState: (state, action: PayloadAction<number>) => {
      const index = state.wishlistProductIds.indexOf(action.payload);
      if (index === -1) {
        state.wishlistProductIds.push(action.payload);
      } else {
        state.wishlistProductIds.splice(index, 1);
      }
    },
    resetWishlist: (state) => {
      state.wishlistProductIds = [];
    },
  },
});

export const {
  setWishlistProductIds,
  addToWishlistState,
  removeFromWishlistState,
  toggleWishlistState,
  resetWishlist,
} = wishlistSlice.actions;

export const getWishlistProductIds = (state: RootState) =>
  state.wishlist?.wishlistProductIds || [];

export const isProductInWishlist = (productId: number) => (state: RootState) =>
  state.wishlist?.wishlistProductIds?.includes(productId) || false;

export default wishlistSlice.reducer;

